const isProduction = process.env.GATSBY_ENV === 'production';

export {
  // eslint-disable-next-line import/prefer-default-export
  isProduction,
};
